import React from "react";
import Typography, { TypographyProps } from "@material-ui/core/Typography";
import { TypographColor } from "./utils";
import cns from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeType } from "@theme";

type Props = TypographyProps & {
  className?: string;
  color?: TypographColor;
};

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    fontSize: theme.typography.fontSize * 0.85
  }
}));

export function Small({ children, className, color = "inherit", ...rest }: Props) {
  const classes = useStyles({});

  return (
    <Typography
      {...rest}
      component={"span" as any}
      color={color}
      className={cns(classes.root, className)}
    >
      {children}
    </Typography>
  );
}

Small.defaultProps = {
  color: "inherit"
};
